// Inline copy of ``building-manager-api-client``'s
// ``getAuthTokenBlocking`` so the inrange-agents web app stays
// self-contained (no cross-repo dependency on the BMA client).
//
// Use case: a mutation handler needs a Bearer token. ``getToken`` may
// return ``undefined`` if the cached token has expired; in that case
// we call ``relogin`` (Kinde re-handshake) and retry once. Throws if
// the token still isn't available - caller surfaces it as a 401.

export type GetTokenFn = () => Promise<string | undefined>;
export type ReloginFn = (() => Promise<void>) | undefined;

export const getAuthTokenBlocking = async (
  getToken: GetTokenFn,
  relogin: ReloginFn,
): Promise<string> => {
  let token = await getToken();

  if (!token && relogin) {
    await relogin();
    token = await getToken();
  }

  if (!token) {
    throw new Error("NO_TOKEN");
  }
  return token;
};
